module.exports = __webpack_public_path__ + "img/gsndc2765_2.bc01df7e.svg";